var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 200,
    fill: "#0060B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.253 89.583H238.414C241.619 89.583 244.693 90.8561 246.959 93.1221L303.544 149.708C305.81 151.974 307.083 155.047 307.083 158.252V238.414C307.083 241.619 305.81 244.692 303.544 246.958L246.959 303.544C244.693 305.81 241.619 307.083 238.414 307.083H158.253C155.048 307.083 151.974 305.81 149.708 303.544L93.1226 246.958C90.8566 244.692 89.5835 241.618 89.5835 238.414V158.252C89.5835 155.047 90.8566 151.974 93.1226 149.708L149.708 93.1221C151.974 90.8561 155.048 89.583 158.253 89.583Z",
    stroke: "white",
    strokeWidth: 20,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M197.73 240.018H198.939V241.226H197.73V240.018Z",
    stroke: "white",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198.333 155.438V203.771",
    stroke: "white",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.40651b2f13f4249850bed358bb4ef9b4.svg";
export { ForwardRef as ReactComponent };